module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pro-audio-d9b3a9b151c73ca72535a1a9de9cb308.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pro-audio.png
// module id = DVY7
// module chunks = 12 16 18